import { generateUUID } from "../../shared/services/utils";
import { promoteOrInsertFirstEmailContact } from "../utils/promote-or-insert-first-email-contact.utils";

export interface ContactDetails {
  id: string;
  contactId: string;
  communicationType: string;
  customCommunicationType?: string;
  provider: string;
  customProvider?: string;
  prefix: string;
  customPrefix?: string;
  details: string;
  location: string;
  customLocation?: string;
  preferred: boolean;
}

export const contactDetailsDefaults = [
  {
    id: "",
    contactId: generateUUID(),
    communicationType: "",
    customCommunicationType: "",
    provider: "",
    customProvider: "",
    prefix: "",
    customPrefix: "",
    details: "",
    location: "",
    customLocation: "",
    preferred: false,
  },
];

export interface Tq1VesselDetailsM {
  techFormSchemaVersion: number | null;
  vesselName: string;
  imoNumber: string;
  gtNt: string;
  maxCraneOutReach: string;
  ConfirmShipHasRightHandedPropeller: string;
  contactDetails: ContactDetails[];
  wlthc: {
    ballast: {
      no1: string | number | undefined;
      midships: string | number | undefined;
      last: string | number | undefined;
    };
    fullBallast: {
      no1: string | number | undefined;
      midships: string | number | undefined;
      last: string | number | undefined;
    };
    fullyLaden: {
      no1: string | number | undefined;
      midships: string | number | undefined;
      last: string | number | undefined;
    };
  };
  heightOfVessel: string;
  loa: string;
  lbp: string;
  mouldedDepth: string;
  lightWeight: string;
  constant: string;
  freshWaterCapacity: string;
  totalHoldCapacityGrainM3: string;
  totalHoldCapacityBaleM3: string;
  blockCoeficient: string;
  Anymodificationsmadesincenewbuiltthataffectconsumption: string;
  listAny: string;
  beam: string;
}

export const vesselDetailsFormInit = (
  vesselName: string | undefined,
  imoNumber: string | undefined,
): Tq1VesselDetailsM => ({
  techFormSchemaVersion: null,
  vesselName: vesselName ?? "",
  imoNumber: imoNumber ?? "",
  gtNt: "",
  maxCraneOutReach: "",
  ConfirmShipHasRightHandedPropeller: "",
  contactDetails: promoteOrInsertFirstEmailContact([]),
  wlthc: {
    ballast: { no1: undefined, midships: undefined, last: undefined },
    fullBallast: { no1: undefined, midships: undefined, last: undefined },
    fullyLaden: { no1: undefined, midships: undefined, last: undefined },
  },
  heightOfVessel: "",
  loa: "",
  lbp: "",
  mouldedDepth: "",
  lightWeight: "",
  constant: "",
  freshWaterCapacity: "",
  totalHoldCapacityGrainM3: "",
  totalHoldCapacityBaleM3: "",
  blockCoeficient: "",
  Anymodificationsmadesincenewbuiltthataffectconsumption: "",
  listAny: "",
  beam: "",
});

export function mapSqlToTq1VesselDetailsForm(
  _vesselInfo: any,
  contacts: any[],
  vesselName: string | undefined,
  imoNumber: string | undefined,
): Tq1VesselDetailsM {
  return {
    techFormSchemaVersion: _vesselInfo?.TECH_FORM_SCHEMA_VERSION ?? null,
    vesselName: _vesselInfo?.VESSEL_NAME ?? vesselName ?? "",
    imoNumber: _vesselInfo?.IMO_NUMBER ?? imoNumber ?? "",
    gtNt: _vesselInfo?.GT_NT ?? "",
    maxCraneOutReach: _vesselInfo?.MAX_CRANE_OUTREACH ?? "",
    ConfirmShipHasRightHandedPropeller: _vesselInfo?.CONFIRM_SHIP_HAS_RIGHT_HANDED_PROPELLER ?? "",

    contactDetails: promoteOrInsertFirstEmailContact(
      Array.isArray(contacts)
        ? contacts.map((contact) => ({
            id: contact?.ID ?? "",
            contactId: contact?.CONTACT_ID ?? "",
            communicationType: contact?.COMMUNICATION_TYPE ?? "",
            customCommunicationType: contact?.CUSTOM_COMMUNICATION_TYPE ?? "",
            provider: contact?.CONTACT_PROVIDER ?? "",
            customProvider: contact?.CUSTOM_PROVIDER ?? "",
            prefix: contact?.CONTACT_PREFIX ?? "",
            customPrefix: contact?.CUSTOM_PREFIX ?? "",
            details: contact?.CONTACT_DETAILS ?? "",
            location: contact?.CONTACT_LOCATION ?? "",
            customLocation: contact?.CUSTOM_LOCATION ?? "",
            preferred: contact?.CONTACT_PREFERRED ?? false,
          }))
        : [],
    ),

    wlthc: {
      ballast: {
        no1: _vesselInfo?.WLTHC_BALLAST_NO1 ?? "",
        midships: _vesselInfo?.WLTHC_BALLAST_MIDSHIPS ?? "",
        last: _vesselInfo?.WLTHC_BALLAST_LAST ?? "",
      },
      fullBallast: {
        no1: _vesselInfo?.WLTHC_FULL_BALLAST_NO1 ?? "",
        midships: _vesselInfo?.WLTHC_FULL_BALLAST_MIDSHIPS ?? "",
        last: _vesselInfo?.WLTHC_FULL_BALLAST_LAST ?? "",
      },
      fullyLaden: {
        no1: _vesselInfo?.WLTHC_FULLY_LADEN_NO1 ?? "",
        midships: _vesselInfo?.WLTHC_FULLY_LADEN_MIDSHIPS ?? "",
        last: _vesselInfo?.WLTHC_FULLY_LADEN_LAST ?? "",
      },
    },

    heightOfVessel: _vesselInfo?.HEIGHT_OF_VESSEL ?? "",
    loa: _vesselInfo?.LOA ?? "",
    lbp: _vesselInfo?.LBP ?? "",
    mouldedDepth: _vesselInfo?.MOULDED_DEPTH ?? "",
    lightWeight: _vesselInfo?.LIGHT_WEIGHT ?? "",
    constant: _vesselInfo?.CONSTANT ?? "",
    freshWaterCapacity: _vesselInfo?.FRESH_WATER_CAPACITY ?? "",
    totalHoldCapacityGrainM3: _vesselInfo?.TOTAL_HOLD_CAPACITY_GRAIN_M3 ?? "",
    totalHoldCapacityBaleM3: _vesselInfo?.TOTAL_HOLD_CAPACITY_BALE_M3 ?? "",
    blockCoeficient: _vesselInfo?.BLOCK_COEFICIENT ?? "",
    Anymodificationsmadesincenewbuiltthataffectconsumption:
      _vesselInfo?.ANY_MODIFICATIONS_MADE_SINCE_NEWBUILT_THAT_AFFECT_CONSUMPTION ?? "",
    listAny: _vesselInfo?.LIST_ANY ?? "",
    beam: _vesselInfo?.BEAM ?? "",
  } as Tq1VesselDetailsM;
}
